import { render, staticRenderFns } from "./QuiltyResourceForm.vue?vue&type=template&id=08065248&"
import script from "./QuiltyResourceForm.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuiltyResourceForm.vue?vue&type=style&index=0&id=08065248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports